// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import {getStorage} from "firebase/storage"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAsHWzc3_1j_kcFFDIiiLyckXMoqy51OPg",
  authDomain: "learneng-20588.firebaseapp.com",
  projectId: "learneng-20588",
  storageBucket: "learneng-20588.appspot.com",
  messagingSenderId: "371427006568",
  appId: "1:371427006568:web:13f796c0a2cc01061a83dd",
  measurementId: "G-LQMLTYG1V0",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app)
